import React, { createContext, useContext, useState, useEffect } from "react";

const CartContext = createContext(null);
const STORAGE_KEY = "dabkazari_cart_v1";

export function CartProvider({ children }) {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (raw) setItems(JSON.parse(raw));
    } catch {}
  }, []);

  useEffect(() => {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(items)); } catch {}
  }, [items]);

  const addItem = (product, size, quantity = 1) => {
    setItems((prev) => {
      const key = `${product.product_id}__${size}`;
      const existing = prev.find((i) => `${i.product_id}__${i.size}` === key);
      if (existing) {
        return prev.map((i) =>
          `${i.product_id}__${i.size}` === key ? { ...i, quantity: i.quantity + quantity } : i
        );
      }
      return [
        ...prev,
        {
          product_id: product.product_id,
          size,
          quantity,
          price_inr: product.price_inr,
          name: product.name,
          image: (product.images && product.images[0]) || "",
        },
      ];
    });
    setOpen(true);
  };

  const removeItem = (product_id, size) => {
    setItems((prev) => prev.filter((i) => !(i.product_id === product_id && i.size === size)));
  };

  const updateQty = (product_id, size, quantity) => {
    setItems((prev) =>
      prev
        .map((i) => (i.product_id === product_id && i.size === size ? { ...i, quantity } : i))
        .filter((i) => i.quantity > 0)
    );
  };

  const clear = () => setItems([]);

  const subtotalInr = items.reduce((s, i) => s + i.price_inr * i.quantity, 0);
  const count = items.reduce((s, i) => s + i.quantity, 0);

  return (
    <CartContext.Provider value={{ items, addItem, removeItem, updateQty, clear, subtotalInr, count, open, setOpen }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
